import { c as _c } from "react/compiler-runtime";
import useUser from 'shared/hooks/use-user';
export const useDownloadInvoiceLink = () => {
  const $ = _c(5);
  const {
    isAffiliate,
    isCustomer
  } = useUser();
  let basePart;
  if ($[0] !== isAffiliate || $[1] !== isCustomer) {
    basePart = "";
    if (isAffiliate) {
      basePart = "/api/dashboard/affiliate/payment/purchase-invoices/download/";
    }
    if (isCustomer) {
      basePart = "/api/dashboard/customer/payment/purchase-invoices/download/";
    }
    $[0] = isAffiliate;
    $[1] = isCustomer;
    $[2] = basePart;
  } else {
    basePart = $[2];
  }
  let t0;
  if ($[3] !== basePart) {
    t0 = invoiceId => basePart ? `${window.location.origin}${basePart}${invoiceId}` : "";
    $[3] = basePart;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};